// extracted by mini-css-extract-plugin
export var cardHeader = "_f2-0";
export var reorderHandle = "_f2-3";
export var titleArea = "_f2-1";
export var titleAreaWithHandle = "_f2-2";